import React from "react";
import SectionTitle from "@src/components/SectionTitle";
import { Lead, Viewmore } from "@src/components/IndexPage/styles";
import { GatsbyImageProps } from "gatsby-plugin-image";
import IntroImg from "./IntroImg";
import { Container, Box, Text } from "./styles";

interface Props {
	sectionTitles: {
		title: string;
		subtitle: string;
	};
	lead: string;
	introImg:
		| React.ReactElement<HTMLImageElement>
		| React.FunctionComponent<GatsbyImageProps>;
	windowW: number | null;
	showGallery: () => void;
}
const GalleryIntro: React.FC<Props> = (props) => {
	const { sectionTitles, lead, introImg, showGallery, windowW } = props;
	return (
		<Container windowW={windowW}>
			<Box>
				<Text windowW={windowW}>
					<SectionTitle {...sectionTitles} align="left" />
					<Lead>{lead}</Lead>
					<Viewmore onClick={showGallery} />
				</Text>
			</Box>
			<IntroImg onClick={showGallery}>{introImg}</IntroImg>
		</Container>
	);
};

export default GalleryIntro;
